import Fetcher from 'utils/fetcher';

const api = new Fetcher();
const apiUrl = process.env.REACT_APP_BACKEND_API;
const apiBaseUrl = process.env.REACT_APP_BACKEND_URI;

export const listTenants = async () => api.get(`${apiUrl}/admin/tenants`, true);
export const getModel = async id =>
  api.get(`${apiUrl}/admin/models/${id}`, true);

export const updateModel = async (modelId, modelInfo) =>
  api.put(`${apiUrl}/admin/models/${modelId}`, modelInfo, true);

export const listAdditionals = async () =>
  api.get(`${apiUrl}/additionals`, true);

export const createAdditional = async additionalInfo =>
  api.post(`${apiUrl}/admin/additionals`, additionalInfo, true);

export const updateAdditional = async (additionalId, additionalInfo) =>
  api.put(`${apiUrl}/admin/additionals/${additionalId}`, additionalInfo, true);

export const getTenantAdditionals = async tenantId =>
  api.get(`${apiUrl}/admin/tenants/${tenantId}/additionals`, true);

export const createTenantAdditionalMatch = async (tenantId, additionalInfo) =>
  api.post(
    `${apiUrl}/admin/tenants/${tenantId}/additionals`,
    additionalInfo,
    true,
  );

export const deleteTenantAdditionalMatch = async (
  tenantId,
  additionalMatchId,
) =>
  api.remove(
    `${apiUrl}/admin/tenants/${tenantId}/additionals/${additionalMatchId}`,
    true,
  );

export const listBookings = async () =>
  api.get(`${apiUrl}/admin/bookings`, true);

export const getBookingPayload = async bookingId =>
  api.get(`${apiBaseUrl}/api/admin/bookings/${bookingId}/payload`, true);

export const refreshBookingPayload = async bookingId =>
  api.post(`${apiBaseUrl}/api/admin/bookings/${bookingId}/update`, null, true);

export const cancelBookingPayload = async bookingId =>
  api.remove(`${apiBaseUrl}/api/booking/${bookingId}`, true);

export const uncancelBooking = async bookingId =>
  api.post(`${apiBaseUrl}/api/admin/bookings/${bookingId}/uncancel`, null, true);

export const listLocations = async () =>
  api.get(`${apiUrl}/admin/locations`, true);

export const createLocation = async locationInfo =>
  api.post(`${apiUrl}/admin/locations`, locationInfo, true);

export const deleteLocation = async iataCode =>
  api.remove(`${apiUrl}/admin/locations/${iataCode}`, true);

export const listModels = async () => api.get(`${apiUrl}/admin/models`, true);

export const listIatas = async code =>
  api.get(`${apiUrl}/IATA?code=${code}`, true);

export const getTenantPlaces = async tenantId =>
  api.get(`${apiUrl}/admin/tenants/${tenantId}/places`, true);

export const getRentlyPlaces = async tenantId =>
  api.get(`${apiUrl}/admin/tenant/info/${tenantId}/places`, true);

export const createTenantPlace = async (tenantId, placeInfo) =>
  api.post(`${apiUrl}/admin/tenants/${tenantId}/places`, placeInfo, true);

export const deleteTenantPlace = async (tenantId, placeId) =>
  api.remove(`${apiUrl}/admin/tenants/${tenantId}/places/${placeId}`, true);

export const updateTenantPlace = async (tenantId, placeId, place) =>
  api.put(`${apiUrl}/admin/tenants/${tenantId}/places/${placeId}`, place, true);

/**
 * Obtiene los adicionales para un tenant
 *
 * @param {string|number} tenantId - ID del tenant
 * @param {boolean} [filterMappeds=false] - 
 *   Indica si deben excluirse de los resultados los adicionales que ya se encuentren
 *   mapeados para RentlyNetwork. Valor opcional; por defecto es `false`
 *   en la api y devuelve todos los resultados
 *
 * @returns {Promise<any>} Promesa con la respuesta de la API
 */
export const getRentlyAdditionals = async (tenantId, filterMappeds) => {
  const baseUrl = `${apiUrl}/admin/tenant/info/${tenantId}/additional`;

  const url = (typeof filterMappeds === "boolean")
    ? `${baseUrl}?filterMappeds=${filterMappeds}`
    : baseUrl;

  return api.get(url, true);
};


export const getTenantModels = async tenantId =>
  api.get(`${apiUrl}/admin/tenants/${tenantId}/models`, true);

export const createTenantModelMatch = async (tenantId, matchInfo) =>
  api.post(`${apiUrl}/admin/tenants/${tenantId}/models`, matchInfo, true);

export const setBrokerSupplierMatch = async matchInfo =>
  api.post(`${apiUrl}/admin/brokers/suppliers`, matchInfo, true);

export const deleteTenantModelMatch = async (tenantId, matchId) =>
  api.remove(`${apiUrl}/admin/tenants/${tenantId}/models/${matchId}`, true);

export const getRentlyCategories = async tenantId =>
  api.get(`${apiUrl}/admin/tenant/info/${tenantId}/categories`, true);

export const listCategories = async () =>
  api.get(`${apiUrl}/admin/categories`, true);

export const listBrokers = async () => api.get(`${apiUrl}/admin/brokers`, true);

export const createBroker = async brokerInfo =>
  api.post(`${apiUrl}/admin/brokers/register`, brokerInfo, true);

export const getBroker = async brokerId =>
  api.get(`${apiUrl}/admin/brokers/${brokerId}`, true);

export const updateBroker = async (brokerId, brokerInfo) =>
  api.put(`${apiUrl}/admin/brokers/${brokerId}`, brokerInfo, true);

export const getBrokerSuppliers = async brokerId =>
  api.get(`${apiUrl}/admin/brokers/${brokerId}/suppliers`, true);

export const updateBrokerSupplier = async (brokerId, mapId, brokerSupplier) =>
  api.post(`${apiUrl}/admin/brokers/${brokerId}/suppliers/${mapId}`, brokerSupplier, true);

export const getBrokerPlaces = async brokerId =>
  api.get(`${apiUrl}/admin/brokers/${brokerId}/places`, true);

export const getTenant = async tenantId =>
  api.get(`${apiUrl}/admin/tenants/${tenantId}`, true);

export const createTenant = async tenantInfo =>
  api.post(`${apiUrl}/admin/tenants`, tenantInfo, true);

export const updateTenant = async (tenantId, tenantInfo) =>
  api.put(`${apiUrl}/admin/tenants/${tenantId}`, tenantInfo, true);

export const getCommercialAgreements = async (brokerId, placeId) => {
  return api.get(
    `${apiUrl}/admin/brokers/${brokerId}/commercial-agreements?placeId=${placeId}`,
    true,
  );
};

export const getModelsForMaintenance = async (tenantModelIds) => {
  return api.get(
    `${apiUrl}/admin/maintenance/test/${tenantModelIds}`,
    true,
  );
};

export const getMaintenanceChecks = async () =>
  api.get(`${apiUrl}/admin/maintenance/checks`, true);

export const getMaintenanceGlobalConfig = async () =>
  api.get(`${apiUrl}/admin/maintenance/global-config`, true);

export const updateMaintenanceGlobalConfig = async (config) =>
  api.post(`${apiUrl}/admin/maintenance/global-config`, config, true);

export const getMaintenanceConfigurations = async (tenantId = null) => {
  const url = tenantId
    ? `${apiUrl}/admin/maintenance/configurations?tenantId=${tenantId}`
    : `${apiUrl}/admin/maintenance/configurations`;
  return api.get(url, true);
};

export const getMaintenanceConfiguration = async (id) =>
  api.get(`${apiUrl}/admin/maintenance/configurations/${id}`, true);

export const createMaintenanceConfiguration = async (config) =>
  api.post(`${apiUrl}/admin/maintenance/configurations`, config, true);

export const updateMaintenanceConfiguration = async (id, config) =>
  api.put(`${apiUrl}/admin/maintenance/configurations/${id}`, config, true);

export const deleteMaintenanceConfiguration = async (id) =>
  api.remove(`${apiUrl}/admin/maintenance/configurations/${id}`, true);

export const getMaintenanceExecutions = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.tenantId) queryParams.append('tenantId', params.tenantId);
  if (params.checkName) queryParams.append('checkName', params.checkName);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.take) queryParams.append('take', params.take);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${apiUrl}/admin/maintenance/executions?${queryString}`
    : `${apiUrl}/admin/maintenance/executions`;
  return api.get(url, true);
};

export const runMaintenanceCheck = async (tenantId, checkName = null) => {
  const url = checkName
    ? `${apiUrl}/admin/maintenance/run/${tenantId}?checkName=${checkName}`
    : `${apiUrl}/admin/maintenance/run/${tenantId}`;
  return api.post(url, {}, true);
};

export const getAvailabilityByIata = async (
  brokerId,
  from,
  to,
  pickUp,
  dropOff,
  commercialAgreementCode,
  ilimitedKm,
  driverAge,
  includeAdditionalPrices,
) => {
  let url = `${apiUrl}/availability?brokerId=${brokerId}&from=${from}&to=${to}&DeliveryLocation=${pickUp}&DropoffLocation=${dropOff}`;

  if (
    commercialAgreementCode &&
    commercialAgreementCode !== '' &&
    commercialAgreementCode !== 'None'
  )
    url += `&commercialAgreementCode=${commercialAgreementCode}`;

  if (!ilimitedKm !== undefined)
    url += `&ilimitedKm=${ilimitedKm}`;

  if (!!driverAge)
    url += `&driverAge=${driverAge}`;

  if (includeAdditionalPrices !== undefined)
    url += `&returnAdditionalsPrice=${includeAdditionalPrices}`;


  return api.get(url, true);
};

export const getAvailabilityByPlace = async (
  brokerId,
  from,
  to,
  pickUp,
  dropOff,
  commercialAgreementCode,
  ilimitedKm,
  driverAge,
  includeAdditionalPrices,
) => {
  let url = `${apiBaseUrl}/v1/api/search?brokerId=${brokerId}&from=${from}&to=${to}&fromPlace=${pickUp}&toPlace=${dropOff}`;

  if (
    commercialAgreementCode &&
    commercialAgreementCode !== '' &&
    commercialAgreementCode !== 'None'
  )
    url += `&commercialAgreementCode=${commercialAgreementCode}`;

  if (!ilimitedKm !== undefined)
    url += `&ilimitedKm=${ilimitedKm}`;

  if (!!driverAge)
    url += `&driverAge=${driverAge}`;

  if (includeAdditionalPrices !== undefined)
    url += `&returnAdditionalsPrice=${includeAdditionalPrices}`;

  return api.get(url, true);
};

export const getAvailabilityByPlaceV2 = async (
  brokerId,
  from,
  to,
  pickUp,
  dropOff,
  commercialAgreementCode,
  ilimitedKm,
  driverAge,
  includeAdditionalPrices,
) => {
  let url = `${apiUrl}/AvailabilityByPlace?brokerId=${brokerId}&from=${from}&to=${to}&DeliveryLocation=${pickUp}&DropoffLocation=${dropOff}`;

  if (
    commercialAgreementCode &&
    commercialAgreementCode !== '' &&
    commercialAgreementCode !== 'None'
  )
    url += `&commercialAgreementCode=${commercialAgreementCode}`;

  if (!ilimitedKm !== undefined)
    url += `&ilimitedKm=${ilimitedKm}`;

  if (!!driverAge)
    url += `&driverAge=${driverAge}`;

  if (includeAdditionalPrices !== undefined)
    url += `&returnAdditionalsPrice=${includeAdditionalPrices}`;

  return api.get(url, true);
};

export const createTestBooking = async (
  booking,
  brokerId,
  commercialAgreementCode,
  selectedAdditionals = [],
) => {
  let url = `${apiUrl}/booking?brokerId=${brokerId}`;

  const modelId = booking.car ? booking.car.model.id : booking.model.id;

  var saveBooking = {
    Customer: {
      FirstName: 'Rently',
      LastName: 'Test',
      EmailAddress: 'bookings@rentlysoft.com',
      DocumentType: 'Passport',
      DocumentId: 'rently-1234',
      BirthDate: '1985-03-13',
    },
    extra: 'Esta es una reserva de prueba / This is a test booking',
    fromDate: booking.fromDate,
    toDate: booking.toDate,
    deliveryPlace: booking.deliveryPlace.id,
    dropoffPlace: booking.returnPlace.id,
    currency: booking.currency,
    model: modelId,
  };

  if (
    commercialAgreementCode &&
    commercialAgreementCode !== '' &&
    commercialAgreementCode !== 'None'
  )
    saveBooking.CommercialAgreementCode = commercialAgreementCode;

  if (selectedAdditionals && selectedAdditionals.length > 0) {
    saveBooking.Additionals = selectedAdditionals.map(item => ({
      AdditionalId: item.id,
      Quantity: item.quantity,
    }));
  }

  return api.post(url, saveBooking, true);
};

export const authenticate = async (username, password) => {
  return api.post(
    `${apiBaseUrl}/connect/token`,
    `username=${username}&password=${password}&grant_type=password&client_id=RentlyAPI`,
    false,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );
};

export const getBookingsGridFilters = async () => api.get(`${apiUrl}/admin/bookings/grid-filters`, true);

export const disableTenant = async (tenantId, options) =>
  api.post(`${apiUrl}/admin/tenants/${tenantId}/disable`, options, true);

export const getTenantWebDeepLink = async tenantId =>
  api.get(`${apiUrl}/admin/tenants/${tenantId}/webdeeplink`, true);

export const updateTenantWebDeepLink = async (tenantId, configValue) =>
  api.put(`${apiUrl}/admin/tenants/${tenantId}/webdeeplink`, { configurationValue: configValue }, true);

export const downloadOriginalRequest = async bookingId =>
  api.get(`${apiUrl}/admin/bookings/${bookingId}/original-request`, true);

export const listUsers = async () => api.get(`${apiUrl}/admin/users`, true);

export const getUser = async userId =>
  api.get(`${apiUrl}/admin/users/${userId}`, true);

export const assignUserRole = async (userId, role) =>
  api.post(`${apiUrl}/admin/users/${userId}/roles`, { role }, true);

export const removeUserRole = async (userId, role) =>
  api.remove(`${apiUrl}/admin/users/${userId}/roles/${role}`, true);

export const inactivateUser = async userId =>
  api.post(`${apiUrl}/admin/users/${userId}/inactivate`, {}, true);

export const createUser = async userInfo =>
  api.post(`${apiUrl}/admin/users`, userInfo, true);

export const forgotPassword = async userName =>
  api.post(`${apiUrl}/admin/users/forgot-password`, { userName }, true);

export const resetPassword = async (userName, token, newPassword) =>
  api.post(`${apiBaseUrl}/v1/auth/reset-password`, { userName, token, newPassword }, false);
